<template>
  <div class="container">
    <!-- 活动规则页面 -->
      <img class="close" @click="unLock" src="../assets/img/guanbi.png" alt="">
        <img class="read-rule" src="../assets/img/text.png" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {
      changeLock: false
    };
  },
  created() {},
  mounted() {},
  methods: {
    unLock() {
      this.$emit("changeStatus", this.changeLock);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/activeDetail.scss";
</style>
